var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYes = function SvgYes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 106",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.551 106c-.33 0-.622-.082-.914-.206a2.029 2.029 0 0 1-1.119-2.294l9.211-41.02-20.377-7.577C.73 54.66.234 54.164.063 53.512c-.165-.657 0-1.31.414-1.842L44.1.74a2.073 2.073 0 0 1 2.49-.533 2.029 2.029 0 0 1 1.118 2.294L38.5 43.522l20.376 7.576c.623.245 1.119.739 1.289 1.391.165.658 0 1.31-.413 1.843l-43.624 50.972a2.153 2.153 0 0 1-1.576.696z"
  })));
};

export default SvgYes;